// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__-AJKj","messages":"Chat_messages__az3Kl","dateDivider":"Chat_dateDivider__1R2s1"};